import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "./Reveal";

const STEPS = [
{ step: "01", title: "Share Your Property", desc: "Tell us about your property location, type, current status. We'll review it and schedule a call within 24 hours." },
{ step: "02", title: "Free Property Health Check", desc: "Our on-ground team conducts a thorough inspection and delivers a detailed health report\xA0 at no cost to you." },
{ step: "03", title: "We Handle Everything", desc: "From tenant sourcing to rent collection, maintenance, legal compliance, and monthly reporting , we run it all." },
{ step: "04", title: "You Receive, We Report", desc: "You collect your returns. We send video updates, reports, and analytics through the tools you already use WhatsApp, email, google meets and soon our dedicated app." }];


export function HowItWorks() {
  const lineRef = useRef(null);
  const isInView = useInView(lineRef, { once: true, margin: "-100px" });

  return (
    <section className="relative py-32 bg-navy-800 text-white noise-overlay overflow-hidden" data-testid="how-it-works-section">
      <div className="pointer-events-none absolute right-0 top-0 h-[600px] w-[600px] -translate-y-1/4 translate-x-1/4 rounded-full bg-emerald-400/5 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-[400px] w-[400px] translate-y-1/4 -translate-x-1/4 rounded-full bg-gold-400/5 blur-3xl" />

      <div className="container-luxury relative">
        <div className="mx-auto max-w-3xl text-center">
          <Reveal>
            <p className="eyebrow text-emerald-300 mb-4">How It Works</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-sans text-display-md font-semibold text-white text-balance leading-tight tracking-tight">
              Simple for You,
              <span className="font-display italic font-normal text-emerald-300"> Powerful for Us</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-lg leading-relaxed text-white/65 sm:text-xl text-balance">
              We work seamlessly through the applications and tools you already use. Our advanced tech platform is launching soon for even greater transparency and control.
            </p>
          </Reveal>
        </div>

        <div className="mt-24 relative">
          <div ref={lineRef} className="absolute top-8 left-0 right-0 hidden lg:block" aria-hidden>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={isInView ? { scaleX: 1 } : {}}
              transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
              className="mx-auto h-px origin-left bg-gradient-to-r from-gold-400/20 via-gold-300/50 to-gold-400/20"
              style={{ maxWidth: "calc(100% - 80px)", marginLeft: "40px" }} />

          </div>

          <div className="grid gap-12 lg:grid-cols-4 lg:gap-8">
            {STEPS.map((step, i) =>
            <Reveal key={step.step} delay={i * 0.12}>
                <div className="relative flex flex-col gap-6">
                  <div className="relative inline-flex h-16 w-16 items-center justify-center">
                    <motion.div initial={{ scale: 0 }} whileInView={{ scale: 1 }} viewport={{ once: true }} transition={{ delay: 0.3 + i * 0.1, type: "spring", stiffness: 200, damping: 18 }} className="absolute inset-0 rounded-full border border-gold-400/30 bg-navy-700" />
                    <span className="relative font-display italic text-gold-400 text-xl">{step.step}</span>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-white tracking-tight leading-snug">{step.title}</h3>
                    <p className="mt-3 text-sm leading-relaxed text-white/60">{step.desc}</p>
                  </div>
                </div>
              </Reveal>
            )}
          </div>
        </div>

        <Reveal delay={0.4}>
          <div className="mt-20 rounded-2xl border border-emerald-400/20 bg-emerald-400/5 px-8 py-7 text-center">
            <p className="text-sm text-white/70">
              <span className="font-semibold text-emerald-300">Advanced Platform Launching Soon — </span>
              A dedicated technology portal for real-time property dashboards, analytics, document vault, and on-demand reports.
            </p>
          </div>
        </Reveal>
      </div>
    </section>);

}